module.exports = __webpack_public_path__ + "img/6.e72d3541.png";